import React from 'react';
import { Link } from 'react-router-dom';
import { IItemForGetShortInfo } from 'types';
import Text from 'components/Text/Text';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ItemList.module.scss';

interface IExtendedItemForGetShortInfo extends IItemForGetShortInfo {
	pathToItem?: string;
}

interface IProps {
	onClickShowAssignModal?: () => void;
	items: IExtendedItemForGetShortInfo[];
	pathToItem?: string;
	assignBtnTranslationKey?: string;
	itemListLabel?: string;
}

export const ItemList: React.FC<IProps> = React.memo(
	({ onClickShowAssignModal, items, pathToItem, assignBtnTranslationKey, itemListLabel }) => {
		return (
			<>
				{itemListLabel && <FullInfoField label={itemListLabel} />}
				<div className={style.list}>
					{items.length ? (
						items.map((el, i) => (
							<div key={`${el.id}__${String(i)}`} className={style.item}>
								<div className={style.dot} />
								{pathToItem || el.pathToItem ? (
									<Link
										className={style.link}
										target={`blank_${Date.now()}`}
										rel="noopener noreferrer"
										to={`${pathToItem || el.pathToItem}${el.id}`}>
										<Text
											className={style.name}
											translationKey={el.name}
											size="s"
											withTooltip={true}
										/>
									</Link>
								) : (
									<Text translationKey={el.name} size="s" withTooltip={true} />
								)}
							</div>
						))
					) : (
						<Text translationNameSpace="form" translationKey="-" />
					)}
				</div>
				{onClickShowAssignModal && (
					<Button
						className={style.editBtn}
						size="sizeS"
						theme="outlined"
						onClick={onClickShowAssignModal}
						icon={
							<svg className={style.icon}>
								<use xlinkHref={`${breadcrumbs}#pencil`} />
							</svg>
						}>
						<Text translationNameSpace="form" translationKey={assignBtnTranslationKey} asFragment={true} />
					</Button>
				)}
			</>
		);
	},
);
